// extracted by mini-css-extract-plugin
export default {"stand":"Stand_stand__+hiMc","inputs":"Stand_inputs__qtKBS","buttons":"Stand_buttons__vQpQe","checkboxes":"Stand_checkboxes__WsITu"};